import { from as observableFrom, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { Fragment } from '../../../core/model/fragment';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';

@Injectable()
export class ShowDocumentsCommandHandler implements ICommandHandler {
  constructor(private _navigationService: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === leaseAgreementCommand.showDocuments && command.context;
    }
    return false;
  }
  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return observableFrom(this._navigationService.navigateChild(['edit', command.context.id], { fragment: Fragment.documentsTab }));
    }
  }
}
